import React from "react";
import ReactECharts from "echarts-for-react";

const AgeWiseStocksChart = ({ data, heading }) => {
  const fullWidthData = data.map((item) => ({
    ...item,
    value: 100,
  }));

  const option = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        const actualValue = Math.floor(data[params.dataIndex].value);
        return `${params.name}<br/>Value: ${actualValue}`;
      },
    },
    grid: {
      left: "5%",
      right: "4%",
      bottom: "3%",
      top: "15%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      max: 100,
      axisLabel: {
        show: false,
        padding: [10, 10],
      },
      splitLine: {
        show: false,
      },
      offset: 10,
    },
    yAxis: {
      type: "category",
      data: fullWidthData.map((item) => item.name),
      axisLabel: {
        padding: [0, 10],
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#000",
        },
      },
    },
    series: [
      {
        type: "bar",
        data: fullWidthData.map((item) => item.value),
        barWidth: 20,
        itemStyle: {
          color: (params) => {
            const colorList = [
              "#5470C6",
              "#91CC75",
              "#EE6666",
              "#FAC858",
              "#73C0DE",
            ];
            return colorList[params.dataIndex % colorList.length];
          },
          borderRadius: [10, 10, 10, 10],
        },
        label: {
          show: true,
          position: "inside",
          formatter: (params) => `${Math.floor(data[params.dataIndex].value)}`,
          fontWeight: 600,
          z: 888,
        },
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ height: 210, width: "100%" }} />
  );
};

export default AgeWiseStocksChart;
